import { Button, Dropdown, MenuProps, Row } from "antd";
import { useMemo } from "react";
import { MoreOutlined } from "@ant-design/icons";

type CreateHistoryProps = {
  isActionsDisabled: boolean;
  onAdd: () => void;
};

export const CreateHistory = ({
  isActionsDisabled,
  onAdd,
}: CreateHistoryProps) => {
  const moreActions: MenuProps["items"] = useMemo(
    () => [
      {
        key: "1",
        label: <Row onClick={onAdd}>Create Payment History</Row>,
      },
    ],
    [onAdd]
  );

  return (
    <Dropdown
      menu={{ items: moreActions }}
      disabled={isActionsDisabled}
      trigger={["click"]}
    >
      <Button icon={<MoreOutlined />} shape="circle" />
    </Dropdown>
  );
};
